import type { RealtimeAlertLevel, RealtimeEngineConfig } from '../../services/api';

export const REALTIME_ALERT_LEVELS: RealtimeAlertLevel[] = ['clean', 'suspicious', 'attention', 'critical'];
export const REALTIME_RUBRIC_MAX_LENGTH = 1200;
export const REALTIME_ALERT_LABELS: Record<RealtimeAlertLevel, string> = {
  clean: 'Clean', suspicious: 'Suspicious', attention: 'Requires attention', critical: 'Critical',
};
export const DEFAULT_REALTIME_ENGINE_CONFIG: RealtimeEngineConfig = {
  alert_rubric: {
    clean: 'Routine activity with no cause for concern.',
    suspicious: 'Unusual activity worth monitoring.',
    attention: 'A meaningful concern requiring attention.',
    critical: 'Immediate danger requiring urgent action.',
  },
};
export const normalizeRealtimeEngineConfig = (value?: RealtimeEngineConfig | null): RealtimeEngineConfig => ({
  alert_rubric: Object.fromEntries(REALTIME_ALERT_LEVELS.map(level => [level, typeof value?.alert_rubric?.[level] === 'string' ? value.alert_rubric[level] : DEFAULT_REALTIME_ENGINE_CONFIG.alert_rubric[level]])) as Record<RealtimeAlertLevel, string>,
});
